export const MENUS_REQUESTED = 'MENUS_REQUESTED'
export const MENUS_SUCCEEDED = 'MENUS_SUCCEEDED'
export const MENUS_ITEMS_NOT_NEEDED = 'MENUS_ITEMS_NOT_NEEDED'
export const MENUS_ITEMS_REQUESTED = 'MENUS_ITEMS_REQUESTED'
export const MENUS_ITEMS_SUCCEEDED = 'MENUS_ITEMS_SUCCEEDED'
export const CURRENT_MENU_SELECTED = 'CURRENT_MENU_SELECTED'
export const CURRENT_MENU_ITEMS_NOT_NEEDED = 'CURRENT_MENU_ITEMS_NOT_NEEDED'
export const CURRENT_MENU_ITEMS_SUCCEEDED = 'CURRENT_MENU_ITEMS_SUCCEEDED'
export const UPDATE_LAST_MENU_REQUEST_TIMESTAMP = 'UPDATE_LAST_MENU_REQUEST_TIMESTAMP'
export const MENUS_AND_ITEMS_REQUESTED = 'MENUS_AND_ITEMS_REQUESTED'

export const menusAndItemsRequested = (ignoreThrottle = false) => ({
  type: MENUS_AND_ITEMS_REQUESTED,
  payload: { ignoreThrottle }
})

export const menusRequested = (ignoreThrottle = false) => ({
  type: MENUS_REQUESTED,
  payload: { ignoreThrottle }
})

export const menusItemsRequested = (ignoreThrottle = false) => ({
  type: MENUS_ITEMS_REQUESTED,
  payload: { ignoreThrottle }
})

export const menusItemsNotNeeded = () => ({
  type: MENUS_ITEMS_NOT_NEEDED,
  payload: { },
})

export const menusItemsSucceeded = data => ({
  type: MENUS_ITEMS_SUCCEEDED,
  payload: data,
})

export const menusSucceeded = data => ({
  type: MENUS_SUCCEEDED,
  payload: data,
})

export const currentMenuSelected = id => ({
  type: CURRENT_MENU_SELECTED,
  payload: id,
})

export const currentMenuItemsNotNeeded = () => ({
  type: CURRENT_MENU_ITEMS_NOT_NEEDED,
  payload: { },
})

export const currentMenuItemsSucceeded = (payload) => ({
  type: CURRENT_MENU_ITEMS_SUCCEEDED,
  payload,
})

export const updateLastMenuRequestTimestamp = (timestamp) => ({
  type: UPDATE_LAST_MENU_REQUEST_TIMESTAMP,
  payload: { timestamp },
})
